import { render } from "./AccountList.vue?vue&type=template&id=07abd8bd&ts=true"
import script from "./AccountList.vue?vue&type=script&lang=ts"
export * from "./AccountList.vue?vue&type=script&lang=ts"

import "./AccountList.vue?vue&type=style&index=0&id=07abd8bd&lang=css"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__